<template>
  <div class="promo">
    <div class="container text-center">
      <img src="/static/images/vestbee_sm_logo.png" alt="" />
      <h2>Connecting worldwide investors with outstanding European startups</h2>
      <div class="promo-form">
        <div :class="{ 'animated fadeInUp': subscribed, hidden: !subscribed }">
          <h4>Thank you for subscribing!</h4>
        </div>
        <div class="input-group hidden" :class="{ hidden: subscribed }">
          <input
            v-model="email"
            type="text"
            class="form-control"
            placeholder="Enter your email"
            @input="markAsChanged()"
          />
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" @click="subscribe()">
              <loader v-show="sending" />
              <span v-show="!sending">Subscribe</span>
            </button>
          </span>
        </div>
        <span
          v-show="errors.email && errors.email.length && !changed"
          class="help-block"
          >Please provide proper e-mail address</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import http from 'services/http'

export default {
  data: function () {
    return {
      email: '',
      errors: {},
      subscribed: false,
      sending: false,
      changed: false,
    }
  },
  methods: {
    markAsChanged() {
      this.changed = true
    },
    subscribe() {
      const self = this
      self.sending = true
      self.changed = false

      http
        .post('/auth/subscribe', { email: this.email })
        .then((res) => {
          self.subscribed = true
          self.sending = false
        })
        .catch((res) => {
          self.sending = false
          self.errors = res.data
        })
    },
  },
}
</script>
